/**
 * Handle personalizable analytics
 *
 * @param container {HTMLElement} data atribut element
 */

const AnalyticsPersonalizable = (container) => {
  const { dataLayer } = window;

  const TriggerClick = () => {
    const child = container.querySelector("[data-analytics-personalized]");

    if (child) {
      dataLayer.push(JSON.parse(child.dataset.analyticsPersonalized));
    } else {
      dataLayer.push(JSON.parse(container.dataset.analyticsPersonalizable));
    }
  };

  container.addEventListener("click", TriggerClick);
};

export default AnalyticsPersonalizable;
